import React from 'react';

import PropTypes from 'apps/age_verification/propTypes';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Fields from 'apps/age_verification/components/forms/Fields';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as normalizers from 'apps/age_verification/components/forms/normalizers';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from 'apps/age_verification/messages';
import { TranslatedMessage } from 'common/components/Intl';
import { AV_NATIONAL_ID_TYPES } from 'apps/age_verification/constants';

const nationalIdField = type => {
  switch (type) {
    case AV_NATIONAL_ID_TYPES.TAX_CODE:
      return TaxCodeField;
    case AV_NATIONAL_ID_TYPES.PASSPORT:
      return PassportNumberField;
    default:
      return SSNField;
  }
};

const SimpleFormSSNFieldGroup = ({ type, disabled, optOutEnabled }) => {
  const NationalIdField = nationalIdField(type);

  return (
    <div className="AddressForm__group">
      <div className="AddressForm__group-title">
        <TranslatedMessage id={m.SSN_TITLE} />
      </div>

      <p className="text flat-blue AddressForm__group-description">
        <TranslatedMessage id={m.SSN_DESCRIPTION} />
      </p>

      <div className="row">
        <div className="col-xs-12">
          <NationalIdField disabled={disabled} />

          {optOutEnabled && (
            <div className="AddressForm_ssn-optout">
              <Fields.SSNOptOut />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SSNField = ({ disabled }) => (
  <div className="AddressForm__ssn">
    <div>###</div>
    <div className="AddressForm__ssn-separator">-</div>
    <div>##</div>
    <div className="AddressForm__ssn-separator">-</div>
    <div className="AddressForm__ssn-input">
      <Fields.SSN normalize={normalizers.maxDigits(4)} disabled={disabled} />
      <Fields.NationalIDNType />
    </div>
  </div>
);

const TaxCodeField = ({ disabled }) => {
  return (
    <div className="AddressForm__tax-code">
      <div className="AddressForm__tax-code-input">
        <Fields.TaxCode normalize={normalizers.taxCode()} disabled={disabled} />
        <Fields.NationalIDNType />
      </div>
    </div>
  );
};

const PassportNumberField = ({ disabled }) => {
  const normalizer = normalizers.passportNumber(
    gon.current_store.cart_tax_country_iso
  );

  return (
    <div className="AddressForm__passport-number">
      <div className="AddressForm__passport-number">
        <Fields.PassportNumber normalize={normalizer} disabled={disabled} />
        <Fields.NationalIDNType />
      </div>
    </div>
  );
};

SimpleFormSSNFieldGroup.propTypes = {
  type: PropTypes.AVNationalIDTypes,
  disabled: PropTypes.bool,
  optOutEnabled: PropTypes.bool,
};

export default SimpleFormSSNFieldGroup;
